export default "__VITE_ASSET__b2bac79b__"